module.exports = __webpack_public_path__ + "static/contentselection-textcontrast-dont-cd12939fffe391bd52bac3d39747f652.png";